import { render, staticRenderFns } from "./validation-errors.vue?vue&type=template&id=833f5bb0"
import script from "./validation-errors.vue?vue&type=script&lang=js"
export * from "./validation-errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports